import { useEffect, type ReactNode } from 'react'

export function Modal(props: {
  open: boolean
  title: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
  testId?: string
}): JSX.Element | null {
  useEffect(() => {
    if (!props.open) return
    function onKey(e: KeyboardEvent): void {
      if (e.key === 'Escape') props.onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [props.open, props.onClose, props])

  if (!props.open) return null
  return (
    <div className="hcc-modal-backdrop" onClick={props.onClose} data-testid={props.testId ?? 'modal'}>
      <div
        className="hcc-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="hcc-modal__header">
          <h2>{props.title}</h2>
          <button
            type="button"
            className="hcc-modal__close"
            aria-label="Close"
            onClick={props.onClose}
          >
            ×
          </button>
        </header>
        <div className="hcc-modal__body">{props.children}</div>
        {props.footer ? <footer className="hcc-modal__footer">{props.footer}</footer> : null}
      </div>
    </div>
  )
}
